import { render, staticRenderFns } from "./imagemagnify.vue?vue&type=template&id=0e6684f8&scoped=true&"
import script from "./imagemagnify.vue?vue&type=script&lang=js&"
export * from "./imagemagnify.vue?vue&type=script&lang=js&"
import style0 from "./imagemagnify.vue?vue&type=style&index=0&id=0e6684f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6684f8",
  null
  
)

export default component.exports